import Chip, { ChipProps, ChipSize } from '@platform-ui-common/components/Chip/index.js';
import Tooltip from '@platform-ui-common/components/Tooltip/index.js';

type PrefilledChipProps = Pick<ChipProps, 'variant' | 'size'> & { plural?: boolean };

export default function PrefilledChip(props: PrefilledChipProps): JSX.Element {
  return (
    <Tooltip title="Prefilled responses are answers you provided on a past application. You can make changes or keep the answers that have been prefilled.">
      <Chip
        size={ChipSize.M}
        icon="task"
        label={`Prefilled Response${props?.plural ? 's' : ''}`}
        {...props}
      />
    </Tooltip>
  );
}
